module.exports = __webpack_public_path__ + "static/media/temp-icon.f0e90a8b.svg";